import styled from 'styled-components';

const CenterContainer = styled.div`
    width: 100%;
    height: 90vh;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export default CenterContainer;
